import { HTMLAttributes, ReactNode } from 'react';

import { colorBgInvertedPrimaryOne } from './inverted-background.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
}

export const InvertedBackground = ({ children, color, ...rest }: Props) => (
    <div style={{ backgroundColor: color ? color : colorBgInvertedPrimaryOne }} {...rest}>
        {children}
    </div>
);
